import type EmberRouter from '@ember/routing/router';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { whenRouteIdle } from 'ember-app-scheduler';
import { modifier } from 'ember-modifier';
import type AnalyticsService from 'parog-web/services/analytics';

function routeIsIntermediate(
  route: NonNullable<RouterService['currentRoute']>
): boolean {
  return route.name.endsWith('_loading') || route.name.endsWith('_error');
}

/**
 * This component is responsible for marking the [Soft LCP](https://developer.chrome.com/docs/web-platform/soft-navigations-experiment?hl=fr)
 * (previously named TTFP) timings.
 *
 * It uses the `whenRouteIdle` utility from `ember-app-scheduler` to wait for the route to be idle before marking the timings.
 *
 * The Soft LCP timing is marked when the route is not an intermediate route (loading or error) and when the route has changed since the last mark.
 */
export default class SoftLCP extends Component {
  @service declare analytics: AnalyticsService;
  @service declare router: RouterService;

  @tracked markedRouteName: EmberRouter['currentRouteName'] = null;

  markSoftLCP = modifier(() => {
    const currentRoute = this.router.currentRoute;

    if (!currentRoute) return;
    if (routeIsIntermediate(currentRoute)) return;
    if (this.markedRouteName == currentRoute.name) return;

    whenRouteIdle().then(() => {
      this.analytics.mark('SoftLCP');
      this.analytics.mark('TTFP');
      this.markedRouteName = currentRoute.name;
    });
  });

  <template>
    <div class='contents' {{this.markSoftLCP}}></div>
  </template>
}
